/** @format **/
import React, { FunctionComponent, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';
import { Typography } from '@material-ui/core';
import I18n from '../../components/Translate/I18n';
import { useDispatch } from 'react-redux';
import { OplSimCardServiceTypeItem } from './component/opl/OplSimCardServiceTypeItem';
import { SimCardServiceTypeItem } from '../../interfaces/collections/SimCardServiceInterface';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../helpers/FormGeneral';

export const ServiceEdit: FunctionComponent<any> = (): React.ReactElement => {
    const dispatch = useDispatch();
    const { id } = useParams();
    const [simCardServiceType, setSimCardServiceType] = useState<SimCardServiceTypeItem | null>(null);

    useEffect(() => {
        if (!simCardServiceType || simCardServiceType['@id'] !== '/' + id) {
            const itemLoader = new ItemLoaders(dispatch);
            itemLoader.getWithCallback(
                FormGeneralHelper.getByUri('/' + id),
                'no-dispatch',
                (data: SimCardServiceTypeItem | null) => {
                    setSimCardServiceType(data);
                },
                { propagateDataToCallback: true, dispatchAfterCallback: false }
            );
        }
    }, [simCardServiceType, id, dispatch]);

    if (simCardServiceType) {
        return <OplSimCardServiceTypeItem simCardServiceType={simCardServiceType} reload={(): void => setSimCardServiceType(null)} />;
    }
    return (
        <GridContainer>
            <GridItem xs={12}>
                <Typography variant="subtitle1">
                    <I18n trans="prov:feature.service_not_supported" />
                </Typography>
            </GridItem>
        </GridContainer>
    );
};
